export const chatQueryKeys = {
  all: ['chat'] as const,
  sessions: () => [...chatQueryKeys.all, 'sessions'] as const,
  pinnedSessions: (search: string) =>
    [...chatQueryKeys.sessions(), 'pinned', search] as const,
  unpinnedSessions: (search: string) =>
    [...chatQueryKeys.sessions(), 'unpinned', search] as const,
  session: (sessionId: string) =>
    [...chatQueryKeys.all, 'session', sessionId] as const,
  participants: (sessionId: string) =>
    [...chatQueryKeys.all, 'participants', sessionId] as const,
  messagesRoot: () => [...chatQueryKeys.all, 'messages'] as const,
  messages: (sessionId: string) =>
    [...chatQueryKeys.messagesRoot(), sessionId] as const,
  messageAttachments: (sessionId: string, messageId: string) =>
    [...chatQueryKeys.all, 'messageAttachments', sessionId, messageId] as const,
  messageAttachmentData: (
    sessionId: string,
    messageId: string,
    attachmentId: string,
  ) =>
    [
      ...chatQueryKeys.all,
      'messageAttachmentData',
      sessionId,
      messageId,
      attachmentId,
    ] as const,
  linkedKnowledgeBases: (sessionId: string) =>
    [...chatQueryKeys.all, 'linkedKnowledgeBases', sessionId] as const,
  sessionDraftAttachments: (sessionId: string) =>
    [...chatQueryKeys.all, 'sessionDraftAttachments', sessionId] as const,
};
